import { usePageData } from "../../../contexts/PageData";

import MainRepairView from "./MainRepair";

const RepairTab = () => {
  const { data } = usePageData() || {};
  return (
   <MainRepairView ticket={data} />
  )
};

export default RepairTab;